<template>
  <div class="flex flex-col gap-2 bg-white rounded-lg p-4">
    <h2 class="text-lg font-semibold text-textPrimary text-left">
      {{ title }}
    </h2>
    <p class="text-md text-textPrimary text-left">
      {{ description }}
    </p>

    <div class="flex flex-col gap-4 mt-4">
      <Checkbox
        v-for="option in options"
        :key="option.value"
        :label="option.label"
        :value="option.value"
        :fieldId="`checkbox-${option.value}`"
        :checked="selected.includes(option.value)"
        @update:checked="onSelect"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import Checkbox from '@/components/designSystem/Checkbox/index.vue'

const props = defineProps<{
  modelValue: string[]
  title: string
  description: string
  options: {
    label: string
    value: string
  }[]
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: string[]): void
}>()

const selected = ref<string[]>(props.modelValue)

const onSelect = (payload: { isChecked: boolean; value: string }) => {
  if (payload.isChecked) {
    if (!selected.value.includes(payload.value)) {
      selected.value.push(payload.value)
    }
  } else {
    selected.value = selected.value.filter((v) => v !== payload.value)
  }
  emit('update:modelValue', selected.value)
}

watch(
  () => props.modelValue,
  (newValue) => {
    selected.value = [...newValue]
  }
)
</script>
